module.exports = __webpack_public_path__ + "static/media/in_a_week_4.a4b62a18.jpg";